module.exports = __webpack_public_path__ + "img/logo-light.ac4d15de.png";